var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDev)?_c('div',{staticClass:"dev",style:(_vm.style),on:{"mouseover":_vm.togglePosition}},[_c('span',[_vm._v("THIS IS DEV MODE! HOST : "+_vm._s(_vm.host))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }